import { ReactNode } from "react"
import { DefaultTemplate, DefaultTemplateProps } from "./default"
import { useIsInEmergency } from "hooks/helps/useIsInEmergency"
import { EmergencyEvent } from "@components/atoms/EmergencyEvent"
import { LoadingComponent } from "@components/atoms/Loading"


export interface EmergencyTemplateProps extends DefaultTemplateProps {
    children: ReactNode
}

export const EmergencyTemplate = ({ children, ...rest }: EmergencyTemplateProps) => {

    const { event, isRefetching, isLoading, isPaused } = useIsInEmergency()
    const { subnavbar, actions, left, right, sideaction, ...r } = rest
    const deactivated = { subnavbar, actions, left, right, sideaction }

    return <DefaultTemplate {...(!event && deactivated)} {...r}>
        {event ?
            <div className="flex flex-col items-center justify-center h-full">
                {isPaused || isLoading ?
                    <LoadingComponent className={`transition-opacity duration-500 ${isLoading ? 'opacity-100' : 'opacity-0'}`} />
                    : <EmergencyEvent event={event} update={isRefetching} />
                }
            </div> :
            children}
    </DefaultTemplate>
    
}